import { useState } from 'react';
import AdminBillingList from './list';
import { CreditCardOutlined } from '@mui/icons-material';

interface AdminBillingPageProps {}

const AdminBillingPage: React.FC<AdminBillingPageProps> = () => {
  // search
  const [search, setSearch] = useState<string>('');
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value);
  };

  // filter
  const [filter, setFilter] = useState<string>('ACTIVE');
  const handleFilterChange = (filter: string) => {
    setFilter(filter);
  };

  // sort
  const [orderBy, setOrderBy] = useState<string | null>('nextBillingDate');
  const [orderDirection, setOrderDirection] = useState<'asc' | 'desc'>('asc');
  const handleRequestSort = (property: string) => {
    const isAsc = orderBy === property && orderDirection === 'asc';
    setOrderDirection(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  // pagination
  const [page, setPage] = useState<number>(0);
  const handleChangePage = (
    _event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => {
    setPage(newPage);
  };
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    setRowsPerPage(event.target.value as unknown as number);
    setPage(0);
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-2">
          <CreditCardOutlined
            sx={{ fontSize: 28 }}
            className="text-orange-400 dark:text-orange-300"
          />
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
            Billing & Subscriptions
          </h1>
        </div>
      </div>

      <AdminBillingList
        page={page}
        search={search}
        filter={filter}
        orderBy={orderBy}
        rowsPerPage={rowsPerPage}
        orderDirection={orderDirection}
        handleChangePage={handleChangePage}
        handleRequestSort={handleRequestSort}
        handleSearchChange={handleSearchChange}
        handleFilterChange={handleFilterChange}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </div>
  );
};

export default AdminBillingPage;
